import React from 'react';
import PropTypes from 'prop-types';
import { bindGa } from 'helpers/analytics';
import s from './LoginAccount.scss';

class LoginAccount extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleClick = this.handleClick.bind(this);
  }

  @bindGa({})
  handleClick() {
    this.props.onClick(this.props.gaLabel);
  }

  render() {
    return (
      <div className={s.login_gray_box}>
        <h3>To Read Full Story</h3>
        <p>Login or create a free The Times Of India Account</p>
        <button
          type="button"
          onClick={this.handleClick}
          data-newga={`${this.props.gaAction}#${this.props.gaLabel}`}
        >
          Login or Create an Account
        </button>
      </div>
    );
  }
}

LoginAccount.propTypes = {
  onClick: PropTypes.func.isRequired,
  gaAction: PropTypes.string.isRequired,
  gaLabel: PropTypes.string.isRequired,
};

export default LoginAccount;
